/**
 * Helper to get a time based session id
 * - used for event ids
 */
export const getSessionId = (): number => 10000 * (Date.parse(new Date().toISOString()) - Date.parse(new Date(2001, 0, 1).toISOString()));
